/** @format */

export function mapQuoteToState(quote) {
    const {order, cart} = quote;

    const updatedOrder = mapOrderToState(order);
    const updatedCart = mapCartToState(cart);

    return {
        lastUpdate: Date.now(),
        isSaving: false,
        order: updatedOrder,
        cart: updatedCart,
        quotedTotal: order.quoted_total,
        uploads: order.order_uploads
    };
}

export function mapOrderToState(order) {
    return {
        id: order.id,
        user_id: order.user_id,
        size_id: order.size_id,
        status_id: order.status_id,
        product_type_id: order.product_type_id,
        size_s3key: order.size_s3key,
        size_type_id: order.size_type_id,
        embossing_type_id: order.embossing_type_id,
        shape_id: order.shape_id,
        width: order.width,
        length: order.length,
        depth: order.depth,
        is_reorder: Boolean(order.is_reorder),
        is_square_corners: Boolean(order.is_square_corners),
        is_special_roll_qty: Boolean(order.is_special_roll_qty),
        is_blank: Boolean(order.is_blank),
        is_embossing: Boolean(order.is_embossing),
        is_design_in_progress: Boolean(order.is_design_in_progress),
        is_reverse_print: Boolean(order.is_reverse_print),
        is_duplex: Boolean(order.is_duplex),
        duplex_aware_total_qty: order.duplex_aware_total_qty,
        duplex_aware_design_qty: order.duplex_aware_design_qty,
        is_account_roll_defaults_applied: order.is_account_roll_defaults_applied,
        is_fewest_possible_rolls: order.is_fewest_possible_rolls,
        roll_max: order.roll_max,
        roll_diameter_max: order.roll_diameter_max,
        roll_qty_max: order.roll_qty_max,
        form_factor_id: order.form_factor_id,
        roll_direction_id: order.roll_direction_id,
        size_description: order.size_description, // for gtag tracking
        color_id: order.color_id,
        duplex_color_id: order.duplex_color_id,
        color_label: order.color_label, // for gtag tracking
        substrate_id: order.substrate_id,
        substrate_label: order.substrate_label, // for gtag tracking
        is_customizable_backing: order.is_customizable_backing,
        substrate_backing_id: order.substrate_backing_id,
        laminate_id: order.laminate_id,
        laminate_label: order.laminate_label, // for gtag tracking
        is_variable_data: Boolean(order.is_variable_data),
        is_variable_print_only: Boolean(order.is_variable_print_only),
        is_printed_proof_only: Boolean(order.is_printed_proof_only),
        is_flat_printed_proof: Boolean(order.is_flat_printed_proof) ? 1 : 0,
        variable_data_special_requests: order.variable_data_special_requests,
        is_high_opacity_black: Boolean(order.is_high_opacity_black),
        is_high_opacity_white: Boolean(order.is_high_opacity_white),
        processing_id: order.processing_id,
        proof_type_id: order.proof_type_id,
        design_qty: order.design_qty,
        total_qty: order.total_qty,
        design_count: order.design_count, // Counter Cached field, do not update
        is_color_matching: order.is_color_matching,
        pantone_qty: order.pantone_qty,
        pantone_comments: order.pantone_comments,
        delay_total: order.delay_total,
        delay_expedite: order.delay_expedite, // Readonly
        delay_standard: order.delay_standard, // Readonly
        delay_processing: order.delay_processing,
        delay_new_size: order.delay_new_size,
        comments_customer: order.comments_customer,
        comments_preprinting: order.comments_preprinting,
        quoted_total: order.quoted_total, // The CostPlusQuoter->subtotal(), no shipping
        customer_label: order.customer_label,
        repeat_length: order.repeat_length,
        ship_due_date: order.ship_due_date,
        ship_due_formatted: order.ship_due_formatted,
        is_front_back: order.is_front_back,
        order_uploads: order.order_uploads,
        quoted_price_per_label: order.quoted_price_per_label,
        quoted_die_charge: order.quoted_die_charge,
        designs_orders: order.designs_orders,
        graphic_design_order_details: order.graphic_design_order_details || {}
    };
}

export function mapCartToState(cart) {
    // Limit the fields
    // We should never update the cart directly. Updating the orders will trigger updates to the cart in the Model/Table
    return {
        id: cart.id,
        order_count: cart.order_count,
        subtotal: cart.subtotal, // Does not include shipping or taxes
        orders: cart.orders // Used for listing orders
    };
}
